// Política de tratamiento de datos de UNA tienda, para su catálogo público
// (Ley 1581 de 2012, Decreto 1377 de 2013). La tienda es la responsable de los
// datos de sus compradores y Vendita el encargado; por eso la política lleva el
// nombre y el contacto de la tienda (`responsableDatos`, del backend).
//
// Si cambia este texto o el de AutorizacionDatos.jsx, subir
// VERSION_AUTORIZACION_DATOS en el backend (src/config/privacidad.js): queda
// grabada con cada autorización como prueba de qué se aceptó.

import React from 'react';
import { createPortal } from 'react-dom';
import { FaTimes } from 'react-icons/fa';

const Seccion = ({ titulo, children }) => (
  <section className="space-y-1">
    <h3 className="font-black text-gray-800 text-sm">{titulo}</h3>
    <div className="text-sm text-gray-600 space-y-1">{children}</div>
  </section>
);

const PoliticaDatosTienda = ({ tienda, onClose }) => {
  const contacto = [tienda.email, tienda.telefono].filter(Boolean).join(' · ');

  return createPortal(
    <div
      className="fixed inset-0 z-[80] bg-black/60 flex items-end md:items-center justify-center p-0 md:p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Política de tratamiento de datos"
        className="bg-white rounded-t-[2rem] md:rounded-[2rem] shadow-2xl w-full max-w-lg max-h-[88vh] flex flex-col"
      >
        <div className="flex items-start justify-between gap-3 px-6 pt-6 pb-3 border-b border-gray-100">
          <div>
            <h2 className="text-lg font-black text-gray-800 leading-tight">Política de tratamiento de datos</h2>
            <p className="text-xs text-gray-400">{tienda.nombre}</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Cerrar" className="p-2 rounded-xl text-gray-400 hover:bg-gray-100">
            <FaTimes />
          </button>
        </div>

        <div className="px-6 py-4 space-y-4 overflow-y-auto">
          <Seccion titulo="Responsable">
            <p>
              <strong>{tienda.nombre}</strong> es responsable de los datos que dejas al hacer un pedido en este catálogo.
            </p>
            {contacto && <p>Contacto: {contacto}</p>}
            {tienda.direccion && <p>Dirección: {tienda.direccion}</p>}
          </Seccion>

          <Seccion titulo="Qué datos usamos">
            <p>Tu nombre y tu celular; tu dirección si pides domicilio, y tu correo si compras un producto digital.</p>
          </Seccion>

          <Seccion titulo="Para qué">
            <ul className="list-disc pl-5 space-y-0.5">
              <li>Recibir, confirmar y entregar tu pedido, y cobrarlo.</li>
              <li>Contactarte por WhatsApp, llamada o correo sobre ese pedido.</li>
              <li>Llevar el historial de tus compras con la tienda.</li>
              <li>Enviarte promociones, <strong>solo si lo autorizas aparte</strong>.</li>
            </ul>
          </Seccion>

          <Seccion titulo="Quién más los trata">
            <p>
              La tienda usa <strong>Vendita</strong> como plataforma: Vendita guarda y procesa tus datos solo por
              encargo de la tienda y para prestarle el servicio. No se venden ni se ceden a terceros.
            </p>
          </Seccion>

          <Seccion titulo="Tus derechos">
            <p>
              Puedes conocer, actualizar, rectificar y pedir que se borren tus datos, solicitar prueba de tu
              autorización y revocarla (incluida la de promociones) escribiéndole a la tienda
              {contacto ? ` (${contacto})` : ''}. Si no te responden, puedes acudir a la Superintendencia de Industria y
              Comercio.
            </p>
          </Seccion>

          <p className="text-[11px] text-gray-400">
            Ley 1581 de 2012 y Decreto 1377 de 2013. Los datos se conservan mientras sean necesarios para esas
            finalidades o hasta que pidas borrarlos, salvo obligación legal de guardarlos.
          </p>
        </div>

        <div className="px-6 pb-6 pt-2">
          <button type="button" onClick={onClose} className="w-full py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-black rounded-xl">
            Entendido
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PoliticaDatosTienda;
